import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Resets the scroll position when the user moves to a different page
 * (sidebar links, buttons that call navigate(), redirects).
 *
 * BrowserRouter has no built-in scroll restoration, so without this the new
 * page opened at the same scroll offset as the previous one.
 *
 * - Only reacts to pathname changes: query/hash updates (tabs, filters) keep
 *   the current position.
 * - Skips POP (browser back/forward) so going back does not force the top.
 * - Besides the window, it also resets any layout content box marked with
 *   `data-route-scroll-root` (they use overflow: scroll).
 */
const ScrollToTopOnNavigate = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === "POP") return;

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document
      .querySelectorAll<HTMLElement>("[data-route-scroll-root]")
      .forEach((el) => {
        el.scrollTop = 0;
        el.scrollLeft = 0;
      });
    // navigationType is read at the moment the pathname changes on purpose.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};

export default ScrollToTopOnNavigate;
